import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";


import { useParams } from 'react-router-dom';

import ProviderCommonApi from '../../../API/provider/common-api';
import { Column, ExcelTable, ImagesViewer, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Icon } from '../../../components/Basic/Elements';
import { Content, PageTitle } from '../../../components/Basic/Global';
import { Input, InputLabel, TextArea } from '../../../components/Basic/Inputs';
import { H1, H3, Text } from '../../../components/Basic/WrapsStyle';
import BarcodesBlock from '../../../components/Common/Input/Barcodes';
import ProductUnitSelect from '../../../components/Providers/Inputs/ProductUnitSelect';
import { formFullDate, getKvantWb } from '../../../utils';
import WbContentButton from '../ContentWork/addToMarketButtons/WbContentButton';
import WbCategorySelect from '../ContentWork/WbCategorySelect';
import styles from './styles.module.scss';
import WbInputName from './WbInputName';

const DEFAULT_KOMUS_PARAMS = [
  'Хит',
  'Новинка',
  'Лучшая цена',
  'Экологичный товар',
  'Схема вложения',
  'Ценовой сегмент',
  'Единица продажи',
  'Ширина',
  'Высота',
  'Глубина',
  'Объем',
  'Вес',
  // 'Единица измерения',
];

const DEFAULT_WB_PARAMS = [
  'Номер сертификата соответствия',
  'ИКПУ',
  'SKU',
  'Дата регистрации сертификата/декларации',
  'Номер декларации соответствия',
  'Дата окончания действия сертификата/декларации',
  'Ставка НДС',
  'Код упаковки',
  // 'Единица измерения',
];

function ProductPage() {
  const match = useParams();
  const navigate = useNavigate();

  console.log('match', match)

  const { sku } = match;

  const [product, setProduct] = useState({});
  const [wbCategory, setWbCategory] = useState({});
  const [wbCharacteristics, setWbCharacteristics] = useState([]);

  const [load, setLoad] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    ProviderCommonApi.getProduct({ data: { sku } })
      .then((r) => r.product)
      .then((product) => {
        setProduct(product);
        setLoad(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.code === 120) {
          setError('Не удалось найти товар в базе');
        }
      });
  }, [sku]);

  const onChange = async (field, value, action) => {

    await ProviderCommonApi.changeProduct({ data: { sku, field, value, action } })
      .then((r) => {
        setProduct(r.product);
      })
      .catch(console.log);
  };

  useEffect(() => {
    const characteristic_provider = {};
    const characteristic_wb = {};

    if (product && load && wbCategory) {
      let wb_characteristics = wbCategory.characteristics || [];

      let properties = (product.properties || []).filter(
        (item) => DEFAULT_KOMUS_PARAMS.indexOf(item.name) === -1 && item.value?.length > 0,
      );
      properties.forEach((item) => (characteristic_provider[item.name] = item.value));
      wb_characteristics.forEach((item) => (characteristic_wb[item.name] = item));

      /// здесь муть , не пойму как здесь меняется state wbCategory (wb_characteristics) через цикл map
      wb_characteristics.map((item) =>
        characteristic_provider[item.name]
          ? (characteristic_wb[item.name].value = characteristic_provider[item.name])
          : (characteristic_wb[item.name].value = ''),
      );
      setWbCharacteristics(wb_characteristics.filter((item) => DEFAULT_WB_PARAMS.indexOf(item.name) === -1));
    }
  }, [wbCategory.category, load]);

  const wb_kvant = getKvantWb(product.purchase, product.content_data?.unit);
  const wb_name = `${product.wb_meta?.name}${wb_kvant}`;

  const onWb = () => { };

  const onChangeCell = (index_line, key, value) => {
    console.log(index_line, key, value);
    let new_array = wbCharacteristics;
    new_array[index_line] = { ...new_array[index_line], [key]: value };
    setWbCharacteristics(new_array);
  };

  let images =
    product.images?.local?.length > 0
      ? product.images?.local
      : product.images?.foreign?.length > 0
        ? product.images?.foreign
        : ['https://api.samsonopt.ru/goods/110983/b2fadb432e3ec30f0ccd03c3b2f624e1_x.jpg'];

  return (
    <>
      <PageTitle title={`Товар: ${product.sku}` || ''} />
      <Content>
        <H1 style={{ marginBottom: 0 }}>{error.length > 0 ? error : product.name}</H1>
        <Row style={{ alignItems: 'flex-start' }}>
          {load && (
            <WhiteBlock style={{ width: '900px' }} title="Данные о товаре">
              <Row style={{ alignItems: 'flex-start' }}>
                <Column style={{ width: '600px' }}>
                  <Row>
                    <InputLabel style={{ marginRight: '10px' }}>Артикул:</InputLabel>{' '}
                    <Text fontWeight={600} style={{ marginRight: '20px' }}>
                      {product.artnumber}
                    </Text>
                    <InputLabel style={{ margin: ' 0 10px' }}>Дата создания:</InputLabel>
                    <Text fontWeight={600}>{formFullDate(product.created_at)}</Text>
                  </Row>
                  <Input
                    label={'Наименование'}
                    value={product.name}
                    onBlur={(v) => onChange('name', v)}
                  />
                  <Row spaceBetween>
                    <Input
                      label={'Бренд'}
                      value={product.brand}
                      width="200px"
                      onBlur={(v) => onChange('brand', v)}
                    />
                    <Input
                      label={'Категория'}
                      value={product.category}
                      width={'370px'}
                      onBlur={(v) => onChange('category', v)}
                    />
                  </Row>
                  <Row style={{ width: '100%', alignItems: 'flex-end' }}>
                    <Input
                      label={'Остаток'}
                      value={product.remains}
                      style={{ marginRight: '15px', width: '110px' }}
                      onBlur={(v) => onChange('remains', v)}
                    />
                    <Input
                      label={'Цена'}
                      value={product.purchase}
                      style={{ marginRight: '15px', width: '110px' }}
                      onBlur={(v) => onChange('purchase', v)}
                    />
                    <div style={{ marginRight: '15px', width: '200px' }}>
                      <BarcodesBlock barcodes={product.barcodes} label={'Штрихкода'} />
                    </div>
                    <ProductUnitSelect
                      label={'Единица измерения'}
                      unit={product.content_data.unit}
                      style={{ width: 'auto' }}
                      onSelect={(v) => onChange('unit', v)}
                      width={'140px'}
                    />
                  </Row>
                </Column>
                <Row className={styles.picture_block}>
                  <ImagesViewer images={images} className={styles.picture} small={false} />
                  <Column style={{ alignSelf: 'flex-start' }}>
                    {images.slice(1).map((item, id) => (
                      <Icon src={item} width={'40px'} key={`${id}img`} />
                    ))}
                  </Column>
                </Row>
              </Row>

              <TextArea
                value={product.description}
                width={'900px'}
                placeholder={'Описание'}
                label={'Описание'}
                maxRow={10}
                onBlur={(v) => onChange('description', v)}
              />

              <H3 style={{ marginTop: '15px' }}>Основная информация</H3>
              <Row>
                <Input
                  label={'Ширина, см'}
                  value={product.content_data.sizes.width}
                  style={{ marginRight: '20px', width: '120px' }}
                  onBlur={(v) => onChange('width', v)}
                />
                <Input
                  label={'Высота, см'}
                  value={product.content_data.sizes.height}
                  style={{ marginRight: '20px', width: '120px' }}
                  onBlur={(v) => onChange('height', v)}
                />
                <Input
                  label={'Глубина, см'}
                  value={product.content_data.sizes.depth}
                  style={{ marginRight: '20px', width: '120px' }}
                  onBlur={(v) => onChange('depth', v)}
                />
                <Input
                  label={'Объем, л'}
                  value={product.content_data.volume}
                  style={{ marginRight: '20px', width: '120px' }}
                  readOnly={true}
                />
                <Input
                  label={'Вес, кг'}
                  value={product.content_data.weight}
                  style={{ marginRight: '20px', width: '120px' }}
                  onBlur={(v) => onChange('weight', v)}
                />
                <Input
                  label={'Срок годности, месяцев'}
                  value={product.term}
                  style={{ marginRight: '15px', width: '170px' }}
                  onBlur={(v) => onChange('term', v)}
                />
              </Row>
              <div style={{ marginTop: '15px' }}>
                <H3 style={{ marginBottom: '15px' }}>Характеристики товара</H3>
                <ExcelTable
                  colWidths={[300, 400]}
                  colHeaders={['Характеристика', 'Значение']}
                  data={(product.properties || []).filter((item) => DEFAULT_KOMUS_PARAMS.indexOf(item.name) === -1)}
                  rowHeaders={true}
                  height="auto"
                  width={'800px'}
                  autoWrapRow={true}
                  autoWrapCol={true}
                  filters={true}
                  dropdownMenu={false}
                  contextMenu={false}
                  multiColumnSorting={false}
                  licenseKey="non-commercial-and-evaluation" // for non-commercial use only
                  columns={[
                    {
                      data: 'name',
                      readOnly: true,
                    },
                    {
                      data: 'value',
                    },
                  ]}
                />
              </div>
            </WhiteBlock>
          )}
          {load && (
            <WhiteBlock title={'Перенос на wb'} className={styles.wb_block} minimize={true}>
              <WbInputName
                label={'Наименование вб сокращенное'}
                value={product.wb_meta.name}
                product={product}
                onChange={(v) => onChange('wb_name', v)}
              />
              <Input
                label={'Наименование вб полное с количеством'}
                value={wb_name}
                readOnly
                style={{ marginBottom: '10px' }}
              />

              <WbCategorySelect
                label={'Категория вб'}
                category={product.wb_category}
                onChange={(v) => onChange('wb_category', v)}
                selectCategory={(v) => setWbCategory(v)}
                style={{ marginBottom: '15px' }}
                initCategory={true}
              />
              <ExcelTable
                colWidths={[300, 300, 100]}
                colHeaders={['Характеристика', 'Значение', 'Валидация']}
                data={wbCharacteristics.filter((item) => DEFAULT_WB_PARAMS.indexOf(item.name) === -1)}
                rowHeaders={true}
                height="auto"
                width={'800px'}
                autoWrapRow={true}
                autoWrapCol={true}
                filters={true}
                dropdownMenu={false}
                contextMenu={false}
                multiColumnSorting={false}
                onChangeCell={onChangeCell}
                columns={[
                  {
                    data: 'name',
                    //readOnly: true,
                  },
                  {
                    data: 'value',
                  },
                  {
                    data: 'charcType',
                  },
                ]}
                style={{ marginTop: '15px' }}
              />O

              {/*         <Button type={TYPE_BUTTONS.WHITE} onClick={saveClickCallback}>
            save
          </Button>*/}

              <WbContentButton
                onClick={(minPurchase, market, join) => onWb(Object.keys(productsSelect), market, minPurchase, join)}
                joinSelect={false}
              />
            </WhiteBlock>
          )}
        </Row>
      </Content>
    </>
  );
}

export default ProductPage;
